import React, { useEffect, useRef } from 'react';
import { Text, Image, Stack, StackItem } from '@fluentui/react';
import { createControlComponent } from "@react-leaflet/core";
import { Marker, Popup, useMap } from 'react-leaflet';
import { LatLng } from 'leaflet';
import moment from 'moment';

import ItemRegistroTiempo from '../../models/ItemRegistroTiempo';
import ItemTarea from '../../models/ItemTarea';

import playIcon from '../../assets/img24/play_24.png';
import flagIcon from '../../assets/img24/finalizado_24.png';
import pauseIcon from '../../assets/img24/pause_24.png';

import 'leaflet';
import "leaflet-routing-machine";
declare let L : any;

const icon : L.Icon = L.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
});

interface ILeafletMapMarkerOrderComponentProps {
    workPart: ItemRegistroTiempo;
    work: ItemTarea;
    selectedWorkPart?: ItemRegistroTiempo;
    selectedStart: boolean;
    onSelect: (workPart: ItemRegistroTiempo, start: boolean) => void;
};

const getLatLng = (value: string) : LatLng => {
    const valueArray : string[] = value.split(',');
    return new LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
};

const LeafletMapMarkerOrderComponent = (props: ILeafletMapMarkerOrderComponentProps) => {
    const map = useMap();

    const markerStartRef = useRef<L.Marker>(null);
    const markerEndRef = useRef<L.Marker>(null);

    useEffect(() => {
        if (props.selectedWorkPart && props.selectedWorkPart.Id === props.workPart.Id) {
            if (props.selectedStart) {
                map.flyTo(getLatLng(props.selectedWorkPart.PosicionGPSInicio), 13);
                markerStartRef.current?.openPopup();
            }
            else {
                map.flyTo(getLatLng(props.selectedWorkPart.PosicionGPSFinal), 13);
                markerEndRef.current?.openPopup();
            }
        }
    }, [props.selectedWorkPart, props.selectedStart, props.workPart.Id, map]);

    const RoutineMachine = createControlComponent(() => {
        const instance = L.Routing.control({
            waypoints: [
                getLatLng(props.workPart.PosicionGPSInicio),
                getLatLng(props.workPart.PosicionGPSFinal),
            ],
            lineOptions: {
                styles: [
                    {
                        color: '#ed6d63', 
                        opacity: 1, 
                        weight: 5,
                    },
                ],
                addWaypoints: false,
            },
            createMarker: function() { 
                return null;
            },
        });
        return instance;
    });
    
    return (
        <>
            {
                props.workPart.PosicionGPSInicio ? (
                    <Marker
                        ref={markerStartRef} 
                        position={getLatLng(props.workPart.PosicionGPSInicio)}
                        icon={icon}
                        eventHandlers={{
                            click: (e: L.LeafletMouseEvent) => {
                                props.onSelect(props.workPart, true);
                            },
                        }}>
                        <Popup>
                            <>
                                <Stack horizontal={true}>
                                    <StackItem>
                                        {
                                            !props.workPart.Fin ? (
                                                <Image 
                                                    src={playIcon}
                                                    alt="Finalizado"
                                                    height={24}
                                                    width={24} />
                                            ) : props.work.FechaFinalizacion ? (
                                                <Image 
                                                    src={flagIcon}
                                                    alt="Finalizado"
                                                    height={24}
                                                    width={24} />
                                            ) : (
                                                <Image 
                                                    src={pauseIcon}
                                                    alt="Finalizado"
                                                    height={24}
                                                    width={24} />
                                            )
                                        }
                                    </StackItem>
                                    <StackItem styles={{
                                        root: {
                                            paddingLeft: 10,
                                        },
                                    }}>
                                        <Text variant="xSmall">
                                            {moment(props.workPart.Inicio).format("DD-MM-YYYY HH:mm")}h - {moment(props.workPart.Fin).format("DD-MM-YYYY HH:mm")}h
                                        </Text>
                                    </StackItem>
                                </Stack>
                                <Text>
                                    {props.workPart.Descripcion}
                                </Text>
                            </>
                        </Popup>
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.workPart.PosicionGPSFinal ? (
                    <Marker
                        ref={markerEndRef}
                        position={getLatLng(props.workPart.PosicionGPSFinal)}
                        icon={icon}
                        eventHandlers={{
                            click: (e: L.LeafletMouseEvent) => {
                                props.onSelect(props.workPart, false);
                            },
                        }}>
                        <Popup>
                            <>
                                <Stack horizontal={true}>
                                    <StackItem>
                                        {
                                            !props.workPart.Fin ? (
                                                <Image 
                                                    src={playIcon}
                                                    alt="Finalizado"
                                                    height={24}
                                                    width={24} />
                                            ) : props.work.FechaFinalizacion ? (
                                                <Image 
                                                    src={flagIcon}
                                                    alt="Finalizado"
                                                    height={24}
                                                    width={24} />
                                            ) : (
                                                <Image 
                                                    src={pauseIcon}
                                                    alt="Finalizado"
                                                    height={24}
                                                    width={24} />
                                            )
                                        }
                                    </StackItem>
                                    <StackItem styles={{
                                        root: {
                                            paddingLeft: 10,
                                        },
                                    }}>
                                        <Text variant="xSmall">
                                            {moment(props.workPart.Inicio).format("DD-MM-YYYY HH:mm")}h - {moment(props.workPart.Fin).format("DD-MM-YYYY HH:mm")}h
                                        </Text>
                                    </StackItem>
                                </Stack>
                                <Text>
                                    {props.workPart.Descripcion}
                                </Text>
                            </>
                        </Popup>
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.workPart.PosicionGPSInicio && props.workPart.PosicionGPSFinal ? (
                    <RoutineMachine />
                ) : (
                    null
                )
            }
        </>
    );
};

export default LeafletMapMarkerOrderComponent;
